<!-- <ng-container *ngIf="userDetails?.stcpay_merchant_id; else readOnlyTemplate">
  <form class="account-setting__merchant-id" name="merchantInfoForm" (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate="">
    <fieldset [ngClass]="{ 'has-error': f.submitted && stcpay_mid.errors?.required }">
      <label><ng-container i18n="@@merchant.stcpay_mid">STCPay MID</ng-container><span class="req-star">*</span></label>
      <div class="account-setting__merchant-id--enter">
        <input type="text" i18n-placeholder="@@merchant.stcpay_mid" placeholder="STCPay MID" name="stcpay_mid" [(ngModel)]="merchantInfo.stcpay_merchant_id" #stcpay_mid="ngModel" class="phone-input" required />
        <span i18n="@@error.stcpay_mid_required" *ngIf="f.submitted && stcpay_mid.errors?.required" class="field-error">STCPay MID is required</span>
        <input type="submit" i18n-value="@@common.save" value="Save">
      </div>
    </fieldset>
  </form>
</ng-container>

<ng-template #readOnlyTemplate>
  <fieldset class="account-setting__merchant-id">
    <label><ng-container i18n="@@merchant.stcpay_mid">STCPay MID</ng-container><span class="req-star">*</span></label>
    <div class="account-setting__merchant-id--enter">
      <input type="text" name="country_code" readonly class="dial-code text-center" [value]="merchantInfo.dial_code">
      <input type="text" readonly name="stcpay_mid" [value]="merchantInfo.stcpay_merchant_id" class="phone-input" />
      <input type="submit" i18n-value="@@ts.common.delete" value="Delete" (click)="deleteMerchant()">
    </div>
  </fieldset>
</ng-template>

 -->
<div class="alert alert-warning w-100" role="alert" *ngIf="labelStatus == 'free_user'; else paid_user">
  <ng-container i18n="@@please_upgrade_your_package_before_dec">
    Please <a href="javascript:;" (click)="goToPlan.emit()"> upgrade your package </a> to continue using the online payment service
  </ng-container>
</div>
<ng-template #paid_user>
  <form [formGroup]="merchantForm" >

    <fieldset class="half" [ngClass]="{'has-error': submitted && merchantForm.controls.merchant_name_en?.errors}">
      <label><ng-container i18n="@@stcpay.merchant_name_en">Merchant name (EN)</ng-container><span class="req-star">*</span></label>
      <input type="text" [attr.readonly]="userDetails?.stcpay?.merchant_name_en" formControlName="merchant_name_en" name="merchant_name_en" class="mt-1">
      <span class="field-error" i18n="@@error.required" *ngIf="submitted && merchantForm.controls.merchant_name_en.errors?.required" >Merchant name is required</span>
      <span class="field-error" *ngIf="submitted && f.merchant_name_en.errors?.serverError">{{ f.merchant_name_en.errors?.serverError }}</span>
    </fieldset>

    <fieldset class="half" [ngClass]="{'has-error': submitted && merchantForm.controls.merchant_name_ar?.errors}">
      <label><ng-container i18n="@@stcpay.merchant_name_ar">Merchant name (AR)</ng-container><span class="req-star">*</span></label>
      <input type="text" [attr.readonly]="userDetails?.stcpay?.merchant_name_ar" formControlName="merchant_name_ar" name="merchant_name_ar" class="mt-1">
      <span class="field-error" i18n="@@error.required" *ngIf="submitted && merchantForm.controls.merchant_name_ar.errors?.required" >Merchant name is required</span>
      <span class="field-error" *ngIf="submitted && f.merchant_name_ar.errors?.serverError">{{ f.merchant_name_ar.errors?.serverError }}</span>
    </fieldset>

    <fieldset class="half" [ngClass]="{'has-error': submitted && merchantForm.controls.merchant_id?.errors}">
        <label><ng-container i18n="@@stcpay.merchant_id">STC Pay MID</ng-container><span class="req-star">*</span></label>
        <input type="text" [attr.readonly]="userDetails?.stcpay?.merchant_id" formControlName="merchant_id" name="merchant_id" class="mt-1">
        <span i18n="@@error.stcpay_mid_required" *ngIf="submitted && merchantForm.controls.merchant_id.errors?.required" class="field-error">STCPay MID is required</span>
        <span class="field-error" *ngIf="submitted && f.merchant_id.errors?.serverError">{{ f.merchant_id.errors?.serverError }}</span>
    </fieldset>

    <fieldset class="half" [ngClass]="{'has-error': submitted && merchantForm.controls.category?.errors}">
      <label><ng-container i18n="@@stcpay.category">Category</ng-container><span class="req-star">*</span></label>
      <input type="text" [attr.readonly]="userDetails?.stcpay?.category" formControlName="category" name="category" class="mt-1">
      <span class="field-error" i18n="@@error.required" *ngIf="submitted && merchantForm.controls.category.errors?.required" >Category is required</span>
      <span class="field-error" *ngIf="submitted && f.category.errors?.serverError">{{ f.category.errors?.serverError }}</span>
    </fieldset>

    <fieldset class="half" [ngClass]="{'has-error': submitted && merchantForm.controls.merchant_url?.errors}">
      <label><ng-container i18n="@@stcpay.merchant_url">Merchant URL</ng-container><span class="req-star">*</span></label>
      <input type="text" [attr.readonly]="userDetails?.stcpay?.merchant_url" formControlName="merchant_url" name="merchant_url" class="mt-1">
      <span class="field-error" i18n="@@error.required" *ngIf="submitted && merchantForm.controls.merchant_url.errors?.required" >Merchant url is required</span>
      <span class="field-error" *ngIf="submitted && f.merchant_url.errors?.serverError">{{ f.merchant_url.errors?.serverError }}</span>
    </fieldset>

    <div class="account-setting__actionButtonsWrap">
      <button *ngIf="!userDetails?.stcpay?.merchant_id" type="submit" (click)="onSubmit(merchantForm)" class="tu-btn pink save-btn" i18n="@@button.save">Save</button>
      <button *ngIf="userDetails?.stcpay?.merchant_id" (click)="deleteMerchant()" type="button" class="tu-btn pink save-btn" i18n="@@ts.common.delete">Delete</button>
    </div>
  </form>
</ng-template>
